// Based on https://github.com/yWorks/yfiles-for-html-demos/blob/58aa22c8e2fd95ee64893a59edef397bc0e1852f/demos/02-tutorial-custom-styles/25-custom-group-style/MyCollapsibleNodeStyleDecoratorRenderer.js
import { createElement } from 'react';
import {
  disposeCallback,
  ensureRoot,
  GroupExpanderVisual,
  SIMPLE_BLOCK_DIAGRAM_COLLAPSE_BUTTON,
} from '@ardoq/graph';
import { createSvgElement } from '@ardoq/dom-utils';
import {
  CollapsibleNodeStyleDecorator,
  IRenderContext,
  Size,
  SvgVisual,
} from '@ardoq/yfiles';

/**
 * Provides a customized visualization of the collapse/expand button of a
 * group node. This implementation delegates the actual rendering of each
 * state to a node style.
 */
class AqCollapsibleNodeStyleDecorator extends CollapsibleNodeStyleDecorator {
  override createButton(
    context: IRenderContext,
    expanded: boolean,
    _size: Size
  ): SVGElement {
    const visual = new SvgVisual(
      createSvgElement('g', {
        class: SIMPLE_BLOCK_DIAGRAM_COLLAPSE_BUTTON,
      })
    );
    ensureRoot(visual.svgElement).render(
      createElement(GroupExpanderVisual, { collapsed: !expanded })
    );
    context.setDisposeCallback(visual, disposeCallback);

    // yFiles support recommends adding the following to prevent the "onClick"
    // from firing when clicking the expand/collapse button
    visual.svgElement.addEventListener(
      'mousedown',
      e => e.stopPropagation(),
      false
    );
    return visual.svgElement;
  }
}

export { AqCollapsibleNodeStyleDecorator };
